import { setUpGraphQLClient } from '@/lib/graphql/client';
import {
  getQAContainerAnswerQuery,
  getQAContainerQuestionQuery,
  getQAContainerServiceQuery,
} from '@/graphql/QAContainerQueries';
import { ScItem } from '@/types/sitecore';
import { merge } from 'lodash';
import {
  QAContainerAnswerFields,
  QAContainerQuestionFields,
  QAContainerQuizItem,
  QAContainerServiceFields,
} from '@/types/components/qa-container';
import { webStorage } from '@/utils/web-storage';
import { S_ITEMS } from '@/utils/web-storage-keys';

export const getQaAnswers = async (ids: string[], lang = 'en-US') => {
  const cache = webStorage.get(S_ITEMS) ?? {};
  const client = setUpGraphQLClient('master');
  const res = await Promise.all(
    ids.map(async (id) => {
      if (!cache[id]) {
        const x: any = await client.request(getQAContainerAnswerQuery(id, lang));
        const service = x.item.service,
          nextQuestion = x.item.nextQuestion;
        const result = {
          id: x.item.id,
          name: x.item.name,
          displayName: x.item.displayName,
          fields: {
            text: x.item.text,
            description: x.item.description,
            nextQuestion: undefined,
            service: undefined,
          },
        } as ScItem<QAContainerAnswerFields>;
        if (service?.id) {
          merge(result.fields, { service: service });
        }
        if (nextQuestion?.id) {
          merge(result.fields, { nextQuestion: nextQuestion });
        }
        cache[id] = result;
        return result;
      } else {
        return cache[id] as ScItem<QAContainerAnswerFields>;
      }
    })
  );
  webStorage.set(S_ITEMS, cache);
  return res;
};
export const getQaService = async (id: string, lang = 'en-US') => {
  const cache = webStorage.get(S_ITEMS) ?? {};
  if (!cache[id]) {
    const client = setUpGraphQLClient('master');
    const res: any = await client.request(getQAContainerServiceQuery(id, lang));
    console.log('getQaService res', res);
    if (!res?.item) return null;
    cache[id] = {
      id: res.item.id,
      name: res.item.name,
      displayName: res.item.displayName,
      fields: {
        title: res.item.title,
        description: res.item.description,
        tag: res.item.tag,
        image: {
          value: res.item.image,
        },
        link: res.item.link,
      },
    } as ScItem<QAContainerServiceFields>;
    webStorage.set(S_ITEMS, cache);
  }
  return cache[id] as ScItem<QAContainerServiceFields>;
};
export const getQaQuestion = async (id: string, lang = 'en-US') => {
  const cache = webStorage.get(S_ITEMS) ?? {};
  if (!cache[id]) {
    const client = setUpGraphQLClient('master');
    const res: any = await client.request(getQAContainerQuestionQuery(id, lang));
    if (!res?.item) return null;
    cache[id] = {
      id: res.item.id,
      name: res.item.name,
      displayName: res.item.displayName,
      fields: {
        question: res.item.question,
        answers: res.item.answers.targetItems.map((x: any) => {
          return {
            id: x.id,
            name: x.name,
            displayName: x.displayName,
            fields: {
              text: x.text,
              nextQuestion: x.nextQuestion,
              service: x.service,
            },
          } as ScItem<QAContainerAnswerFields>;
        }),
      },
    } as ScItem<QAContainerQuestionFields>;
    webStorage.set(S_ITEMS, cache);
  }
  return cache[id] as ScItem<QAContainerQuestionFields>;
};
